import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "d-flex justify-content-between w-100 align-items-center"
};
const _hoisted_2 = {
  class: "sort-direction-button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_chevron_up_icon = _resolveComponent("chevron-up-icon");
  const _component_chevron_down_icon = _resolveComponent("chevron-down-icon");
  const _component_chevron_selector_vertical_icon = _resolveComponent("chevron-selector-vertical-icon");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  return _openBlock(), _createBlock(_component_flex_row, {
    id: $props.id,
    styles: {
      width: '100%',
      lineHeight: '16.9px'
    },
    align: "left",
    gap: 8
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default"), _createElementVNode("div", _hoisted_1, [$props.direction === 'asc' ? (_openBlock(), _createBlock(_component_chevron_up_icon, {
      key: 0,
      width: "12",
      height: "12"
    })) : $props.direction === 'desc' ? (_openBlock(), _createBlock(_component_chevron_down_icon, {
      key: 1,
      width: "12",
      height: "12"
    })) : $props.showNeutral ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
      key: 2,
      width: 'fit-content'
    }, {
      title: _withCtx(() => [_createTextVNode(_toDisplayString($props.sortButtonDescription?.detail), 1)]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_chevron_selector_vertical_icon, {
        width: "12",
        height: "12"
      })])]),
      _: 1
    })) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "more-head-actions")])]),
    _: 3
  }, 8, ["id"]);
}